import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import { DataGrid } from '@mui/x-data-grid';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import {GET_ALL_GROWER_CAPACITY} from '../../../common/URLs';

import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material';

import React, { useState, useEffect } from "react";

import { toast } from 'react-toastify';
import apiClient from '../../../axios';

function GrowerPopUp() {


   
   useEffect(()=>{
     getGrowerDetails();
   },[])


   const getGrowerDetails = ()=>{
    apiClient
    .post(GET_ALL_GROWER_CAPACITY,
      {
       
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      console.log(response.data);
      //let i =0;
      response?.data?.growerCapacityList?.forEach((item,index)=>{
        item.id= index
      })
      setRows(response?.data?.growerCapacityList);
    })
    .catch(function (error) {
      console.log(error);
      toast.error(error.message);
    });

   }
    const [rows,setRows] = useState([]);

    const columns = [
  
      { field: 'growerUrn', headerName: 'Grower URN', width: 200 },
  
      { field: 'growerName', headerName: 'Grower Name', width: 300 },
  
      { field: 'growerLandId', headerName: 'Grower Contact', width: 300 },
  
      { field: 'growerCurrentBalance', headerName: 'Capacity', width: 200 }
  
     
  
    //   {
  
    //     field: 'View Details', width: 120,
  
    //     renderCell: (cellValues) => {
  
    //       return (
  
    //         <Button
  
    //           variant="contained"
  
    //           color="primary"
  
  
  
  
    //         >
  
    //           Click Here
  
    //         </Button>
  
    //       );
  
    //     }
  
    //   },
  
    ];
  
  
  
  
  
  
    return (
  
  
  
  
  
      <Container fluid>
  
      
        <br></br>
  
        {/* <Row>
          
  
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA',float:"right", marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>To be Loaded</Typography>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="card-tr">
             <div  style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA', float:"right",marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>In-transit</Typography>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{ cursor: "pointer",textDecoration:"underline",color: '#005BAA', float:"right",marginRight: '1vw', marginTop: '0vh', }}>Click to view list</div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Unloaded</Typography>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA',float:"right", marginRight: '1vw', marginTop: '0vh',  }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>GRN Complete</Typography>
            </div>
          </Col>
  
          <br></br>
          <br></br>
  
  
        </Row>
   */}
  
        <br></br>
  
        <Card>
  
          <Box style={{ height: 350, width: '100%' }}>
  
           
  
            <DataGrid rows={rows}
  
              columns={columns}
  
              pageSize={10}
  
  
  
  
            />
  
          
  
  
  
  
          </Box>
  
        </Card>
  
      </Container>
  
  
  
  
    )
  
  
  
  
  }
  
  export default GrowerPopUp;





